module.exports = __webpack_public_path__ + "img/ic_16_fitnessplan_edit.fa71d73b.svg";